<template>
  <div>
    <div class="download-box">
      <div class="title">超级白板埋点使用统计</div>
      <div class="date-box">
        <span>请选择时间：</span>
        <DatePicker
          type="daterange"
          v-model="time"
          placement="bottom-end"
          placeholder="请选择时间"
          style="width: 200px"
          @on-change="timeChange"
        />
      </div>
      <div class="date-box">
        <span>统计方式：</span>
        <Select v-model="type" style="width: 200px">
          <Option value="1">埋点总数统计</Option>
          <Option value="2">学校维度统计</Option>
          <Option value="3">全部学校维度统计</Option>
        </Select>
      </div>
      <Button type="primary" class="button" @click="downloadData">导出</Button>
    </div>
  </div>
</template>

<script>
export default {
  name: "download",
  data() {
    return {
      type: "1",
      startTime: "",
      endTime: "",
      time: [],
    };
  },
  methods: {
    /**
     * @name 切换时间
     */
    timeChange(data) {
      this.startTime = data[0];
      this.endTime = data[1];
    },
    /**
     * @name 下载
     */
    downloadData() {
      let link="";
      if(this.type=='3'){
        link="website/superWhiteboardStats/exportStatsData?type=";
      }else{
        link="/website/superWhiteboardStats/exportStatsData?type=";
      }
      let url =
        process.env.VUE_APP_APIURL +
        link +
        this.type +
        "&startTime=" +
        this.startTime +
        " 00:00:00" +
        "&endTime=" +
        this.endTime +
        " 23:59:59";
      let iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = url;
      iframe.onload = function () {
        document.body.removeChild(iframe);
      };
      document.body.appendChild(iframe);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.download-box {
  position: relative;
  width: 700px;
  height: 500px;
  margin: auto;
  margin-top: 50px;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 4px 12px rgb(0 0 0 / 15%);
  .title {
    text-align: left;
    font-size: 22px;
    font-weight: bold;
  }
  .date-box {
    margin-top: 50px;
    text-align: left;
  }
  .button {
    position: absolute;
    bottom: 20px;
  }
}
</style>
